var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3H3.5C2.672 3 2 3.67125 2 4.5V19.5C2 20.3288 2.672 21 3.5 21H21.5C22.3288 21 23 20.3288 23 19.5V4.5C23 3.67125 22.3288 3 21.5 3ZM21.5 19.5H3.5V4.5H21.5V19.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5H10.25V9H5V7.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5H8V12H5V10.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 13.5H13.25C12.0073 13.5 11 14.5073 11 15.75V17.25H12.5V15.75C12.5 15.336 12.836 15 13.25 15H17.75C18.164 15 18.5 15.336 18.5 15.75V17.25H20V15.75C20 14.5073 18.9928 13.5 17.75 13.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.25C16.3288 8.25 17 8.92125 17 9.75C17 10.5788 16.3288 11.25 15.5 11.25C14.672 11.25 14 10.5788 14 9.75C14 8.92125 14.672 8.25 15.5 8.25ZM15.5 12.75C17.1568 12.75 18.5 11.4068 18.5 9.75C18.5 8.09325 17.1568 6.75 15.5 6.75C13.8432 6.75 12.5 8.09325 12.5 9.75C12.5 11.4068 13.8432 12.75 15.5 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.1650dac5401561c9730f0ac4af997ed0.svg";
export { ForwardRef as ReactComponent };